import { render } from "./Index_news_en_m.vue?vue&type=template&id=4e41d727&scoped=true"
import script from "./Index_news_en_m.vue?vue&type=script&lang=js"
export * from "./Index_news_en_m.vue?vue&type=script&lang=js"

import "./Index_news_en_m.vue?vue&type=style&index=0&id=4e41d727&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e41d727"

export default script